import { useQuery } from '@tanstack/react-query';

import {
    eventDashboardStatsQueryOptions,
    selectRevenueStats,
} from '../eventDashboardStatsQueryOptions';

type UseEventDashboardRevenueOptions = {
    eventId: number | undefined;
    timezone: string;
};

/**
 * Revenue card hook. Shares the dashboard query cache with the other cards —
 * only the derived `data` shape differs thanks to `select`.
 */
export function useEventDashboardRevenue({ eventId, timezone }: UseEventDashboardRevenueOptions) {
    return useQuery({
        ...eventDashboardStatsQueryOptions({ eventId, timezone }),
        select: selectRevenueStats,
    });
}
